import React from 'react';
import './recommendedJobPostCardDetail.css';
import backgroundImage from "./gourmet-card.png";
import { locationIcon, shopIcon, scheduleIcon, usersIcon, timerIcon } from "../../../../../utils/icons";
import { useNavigate, useLocation, Link } from 'react-router-dom';

const RecommendJobDetailPostCard = ({ data }) => {
  const navigate = useNavigate();

  const handleApplyRedirect = () => {
    navigate(`/trabajos/${data.id}/aplicar`);
    window.scrollTo(0, 0); 
  };

  const handleDetailRedirect = () => {
    navigate(`/trabajos/${data.id}`, { state: { scrollToOffers: true } });
    window.scrollTo(0, 0); 
  };

  const handleLocationDisplay = () => {
    if (data.location === null) {
      return 'No especificado';
    }
    return data.location.address;
  };
  
  const profileImage = data.restaurant?.profileImageUrl || '/default-restaurant.png';
  
  const handleImageError = (e) => {
    e.target.src = '/default-restaurant.png';
  };

  return (
    <div className="recommended-job-detail-post-card__container">
    <div className="recommended-job-detail-post-card__image-container">
      <img className="recommended-job-detail-post-card__brackground-image" src={backgroundImage} alt="Background" />
      <img 
        className="recommended-job-detail-post-card__image" 
        src={profileImage} 
        alt="Avatar" 
        onError={handleImageError}
      />
    </div>
    <div className="recommended-job-detail-post-card__details-container">
      <h1>{data.position}</h1>
      <h2>{data.restaurant.name}</h2>
      <div className="recommended-job-detail-post-card__information-container">
        <div className="recommmended-job-card__icon-title-container">
          {shopIcon}
          <div className="recommended-job-detail-post-card__info-label-container" >
            <p><strong>Establecimiento:</strong></p>
            <p>{data.restaurant.format}</p>
          </div>
        </div>
        <div className="recommmended-job-card__icon-title-container">
          {locationIcon}
          <div className="recommended-job-detail-post-card__info-label-container">
            <p><strong>Ubicación:</strong></p>
            <p>{handleLocationDisplay()}</p>
          </div>
        </div>
        <div className="recommmended-job-card__icon-title-container">
          {timerIcon}
          <div className="recommended-job-detail-post-card__info-label-container">
            <p><strong>Jornada:</strong></p>
            <p>{data.schedule}</p>
          </div>
        </div>
        <div className="recommmended-job-card__icon-title-container">
          {usersIcon}
          <div className="recommended-job-detail-post-card__info-label-container">
            <p><strong>Vacantes:</strong></p>
            <p> {data.vacancies}</p>
          </div>
        </div>
      </div>
      <div className="recommended-job-detail-post-card__buttons-container">
            <button onClick={handleApplyRedirect} className="recommended-job-detail-post-card__button">
              Postular
            </button>
            <button onClick={handleDetailRedirect} className="recommended-job-detail-post-card__button">
              Detalle
            </button>

      </div>
    </div>
    </div>
  );
};

export default RecommendJobDetailPostCard;


